import * as React from "react";

export function useCopyToClipboard({ timeout = 2000 } = {}) {
  const [isCopied, setIsCopied] = React.useState(false);

  const copyToClipboard = async (value) => {
    if (typeof window === "undefined" || !value) {
      return;
    }

    try {
      // Try using the Clipboard API first
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        setIsCopied(true);
      } else {
        // Fallback for browsers that don't support clipboard API
        const textarea = document.createElement("textarea");
        textarea.value = value;
        textarea.style.position = "fixed";
        textarea.style.left = "-999999px";
        textarea.style.top = "-999999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          document.execCommand("copy");
          setIsCopied(true);
        } catch (err) {
          console.error("Failed to copy text:", err);
          return;
        } finally {
          document.body.removeChild(textarea);
        }
      }

      setTimeout(() => {
        setIsCopied(false);
      }, timeout);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  return { isCopied, copyToClipboard };
}

export default useCopyToClipboard;
